import { useState, useCallback } from "react";


const useSubmitVatugJob = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);

  const submit = useCallback(async (payload) => {
    setIsLoading(true);
    setIsSuccess(false);
    setIsError(false);
    setError(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/vatugJobs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message = data?.message || "Failed to submit";
        throw new Error(message);
      }

      setIsSuccess(true);
      return data;
    } catch (err) {
      setIsError(true);
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { submit, isLoading, isSuccess, isError, error };
};

export default useSubmitVatugJob; 